import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import MessageSellSideButton from 'router/subrouters/DataRoom/subrouters/components/MessageSellSideButton';

import './DataRoomDocEmpty.styles.scss';

type DataRoomDocEmptyProps = {
  className?: string;
};

const DataRoomDocEmpty: React.FC<DataRoomDocEmptyProps> = (props) => {
  const { className } = props;

  const { isPublishingAllowed } = useContext(DataRoomContext);

  const classes = classNames('data-room-doc-empty', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="There are no files yet."
      />

      <p>{t(isPublishingAllowed ? 'startAddingDocsDR' : 'noFilesAvailable')}</p>

      <MessageSellSideButton />
    </div>
  );
};

export default DataRoomDocEmpty;
